import { MuiThemeContextModel } from "./mui-theme.types";

export const useMuiThemeLogic = (): MuiThemeContextModel => {
  return {};
};
